import { ZoPPMStruktPodmienkaSpecRef } from './zo-ppmstrukt-podmienka-spec-ref';

/**
 * 
 * @export
 * @interface ZoPPMStruktPodmienka
 */
export interface ZoPPMStruktPodmienka {
    /**
     * 
     * @type {string}
     * @memberof ZoPPMStruktPodmienka
     */
    'poznamka'?: string;
    /**
     * 
     * @type {string}
     * @memberof ZoPPMStruktPodmienka
     */
    'vyjadrenie'?: ZoPPMStruktPodmienkaVyjadrenieEnum;
    /**
     * 
     * @type {ZoPPMStruktPodmienkaSpecRef}
     * @memberof ZoPPMStruktPodmienka
     */
    'zoppmStruktPodmienkaSpecRef'?: ZoPPMStruktPodmienkaSpecRef;
}

export const ZoPPMStruktPodmienkaVyjadrenieEnum = {
    Ano: 'ANO',
    Nie: 'NIE',
    NetykaSa: 'NETYKA_SA'
} as const;

export type ZoPPMStruktPodmienkaVyjadrenieEnum = typeof ZoPPMStruktPodmienkaVyjadrenieEnum[keyof typeof ZoPPMStruktPodmienkaVyjadrenieEnum];


